
import AV from "leancloud-storage";
import { Topic } from "@/models";
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'

import { mapGetters } from "vuex";
import TopicHeader from "@/components/topic/TopicHeader.vue";
import PostItem from "@/components/PostItem.vue";


export default {
name: "PostTopic",
created() {
let id = this.$route.params.id;

Topic.getById(id).then((topic) => {
this.topic = topic;
});

this.getLatestTopicPosts();
this.getHotTopicPosts();
},
data() {
return {
topic: null,
index: 0,
postsByTime: [],
postsByLikesCount: [],
postsByTimePage: 1,
postsByLikesCountPage: 1,
showFullDesc: false,
loading: false,

};
},
scrollBottom() {
if (this.loading) {
return;
}

if (this.index == 0) {
this.getLatestTopicPosts(this.postsByTimePage + 1);
} else {
this.getHotTopicPosts(this.postsByLikesCountPage + 1);
}
},
methods: {
getLatestTopicPosts: function (page = 1) {
let id = this.$route.params.id;

this.loading = true;
Topic.getLatestTopicPosts(id, page)
.then((posts) => {
if (page == 1) {
this.postsByTime = posts;
} else {
this.postsByTime = this.postsByTime.concat(posts);
}

this.postsByTimePage = page;
this.loading = false;
})
.catch((err) => {
this.loading = false;
});
},

getHotTopicPosts: function (page = 1) {
let id = this.$route.params.id;

this.loading = true;
Topic.getHotTopicPosts(id, page)
.then((posts) => {
if (page == 1) {
this.postsByLikesCount = posts;
} else {
this.postsByLikesCount = this.postsByLikesCount.concat(posts);
}

this.postsByLikesCountPage = page;
this.loading = false;
})
.catch((err) => {
this.loading = false;
});
},













async didCreatePost(post) {
this.$vux.loading.show();

try {
await AV.Cloud.rpc("addPostToTopic", {
postId: post.id,
topicId: this.topic.id,
});

this.$vux.loading.hide();

this.$vux.toast.show({
text: "发表成功",
});

setTimeout(() => {
this.$vux.toast.hide();
this.postsByTime.unshift(post.toJSON());
}, 1000);
} catch (err) {
console.log(err);
this.$vux.loading.hide();
}
},
},

computed: {
...mapGetters(["user"]),
},
components: {
PostItem,
Tab,
TabItem,
TopicHeader,

},
};



// WEBPACK FOOTER //
// ./src/pages/PostTopic.vue